import React from 'react';
import './Sidebar.css';
import logo from './Logomarca Cooperval-05.png';
import styled from "styled-components";

const BackgroundImage = styled.img`
  position: absolute;
  top: 50%; /* Centraliza verticalmente */
  left: 50%; /* Centraliza horizontalmente */
  transform: translate(-50%, -50%); /* Ajusta a imagem para o centro exato */
  width: 500px; /* Define o tamanho da imagem */
  height: 100px;
  padding: 0px 20px 20px 0px; /* Adiciona o espaçamento */
  z-index: -1; 

  @media (max-width: 768px) {
    width: 200px; /* Define o tamanho da imagem */
    height: auto;
  }
`;

const LoadingMessage = styled.p`
  font-size: 24px;
  font-weight: 700;
  color: #555;
  text-align: center;
  margin: 30px;

  &::after {
    content: '';
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-left: 10px;
    border: 2px solid #ccc;
    border-top: 2px solid #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    vertical-align: middle;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const GridBi = ({ currentUrl, loading, setLoading }) => {
  return (
    <>
      {loading && (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '82vh' }}>
          <LoadingMessage>Carregando dados, por favor aguarde...</LoadingMessage>
        </div>
      )}

      {currentUrl && (
        <iframe
          src={currentUrl}
          title="iframe"
          className="iframe"
          onLoad={() => setLoading(false)} // quando o Power BI carregar
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            display: loading ? 'none' : 'block'
          }}
        />
      )}

      {!currentUrl && !loading && (
        <BackgroundImage
          src={logo}
          style={{ width: '500px', height: '100px', padding: '0px 20px 20px 0px' }}
          alt="Logo"
        />
      )}
    </>
  );
};


export default GridBi;
